import Filters from './component';

export default Filters;
